import { performRequest, performRequestThird } from 'common/apiHandler';
import { default as apiEndPoints } from 'common/apiEndPoints';
import { getTenantDetails } from 'utils/utils';

export const listContacts = (obj) => {
  const {
    contactType,
    contactStatus = 'ACTIVE',
    keyWord = '',
    is_court_location = '',
    is_event_location = '',
    pageLimit = 10,
    pagination_token = '',
    pagination_direction = 'forward',
    in_lead = false,
    excludeFromLoading = false,
    is_referral_entity = false,
    bussiness_person_only = false,
    /** When true, always send contact_type (may be empty), in_lead, and is_referral_entity on the query string. */
    explicitContactFilters = false,
  } = obj;

  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.contact.list}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&contact_status=${contactStatus}&keyword=${keyWord}&is_court_location=${is_court_location}&is_event_location=${is_event_location}&limit=${pageLimit}&pagination_token=${pagination_token}&pagination_direction=${pagination_direction}`;
  if (explicitContactFilters) {
    url += `&contact_type=${encodeURIComponent(contactType ?? '')}&in_lead=${in_lead}&is_referral_entity=${is_referral_entity}`;
  } else {
    if (contactType) url += `&contact_type=${contactType}`;
    if (in_lead) url += `&in_lead=${in_lead}`;
    if (is_referral_entity) url += `&is_referral_entity=${is_referral_entity}`;
  }
  if (bussiness_person_only) url += `&bussiness_person_only=${bussiness_person_only}`;
  return performRequest(apiEndPoints.methodType.GET, url, null, '', true, excludeFromLoading);
};

export const emailDuplicateCheck = (email) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.contact.emailValidation}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&email=${encodeURIComponent(email)}`;
  return performRequestThird(apiEndPoints.methodType.GET, url, null, '', true, true);
};
